import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { SubmitKnowledgeFormCommand } from '@/app/knowledge-form/commands/submit-knowledge-form.command'

const httpClient = new AxiosClient()

export const submitKnowledgeFormCommand = new SubmitKnowledgeFormCommand(httpClient, store)
